import { EMPTY_LIST, ENTITY_LISTING_VIEW_TYPE } from '../../../constants/common'
import {
  getListViewTypeWithPreview,
  isListViewTypeWithPreview,
} from '../../../utils/listViewType'
import {
  getIsListingPublicationLive,
  getListingPortalLabel,
  LISTING_VIEW_TYPES,
  LISTINGS_FILTER_PARAM,
} from '../../RentalPortalListing'

export function getListingsStatusFilterValues({ filterValues, status }) {
  return { ...filterValues, [LISTINGS_FILTER_PARAM.status]: [status] }
}

export function getListingLivePortalNames(listing) {
  return (listing.portal_status_summary ?? EMPTY_LIST)
    .filter(getIsListingPublicationLive)
    .map(publication => getListingPortalLabel(publication.portal))
}

export function getListingsLivePublicationCount(listings) {
  return listings.filter(
    listing => getListingLivePortalNames(listing).length > 0
  ).length
}

export function getListingsSavedViewType(view) {
  return LISTING_VIEW_TYPES.includes(view)
    ? view
    : ENTITY_LISTING_VIEW_TYPE.table
}

export function getListingsTableViewType(listViewType) {
  return isListViewTypeWithPreview(listViewType)
    ? getListViewTypeWithPreview(ENTITY_LISTING_VIEW_TYPE.table)
    : ENTITY_LISTING_VIEW_TYPE.table
}
